import {
  StockMovementType,
  StockObjectType,
  StockObjectTypeCar,
} from 'src/packages/warehouse';

/**
 * export type StockObjectType =
 *   | 'Warehouse::Basket'
 *   | 'Warehouse::Bufferstock'
 *   | 'Warehouse::Inventur'
 *   | 'Warehouse::OrderAcceptance'
 *   | 'Warehouse::Order'
 *   | 'Warehouse::Stock';
 */
/** Backend-Typname des StockObject-Typs Basket (Warenkorb). */
export const STOCK_OBJECT_TYPE_BASKET: StockObjectType = 'Warehouse::Basket';
/** Backend-Typname des StockObject-Typs Bufferstock. */
export const STOCK_OBJECT_TYPE_BUFFERSTOCK: StockObjectType =
  'Warehouse::Bufferstock';
/** Backend-Typname des StockObject-Typs Inventur. */
export const STOCK_OBJECT_TYPE_INVENTUR: StockObjectType = 'Warehouse::Inventur';
/** Backend-Typname des StockObject-Typs OrderAcceptance (Bestellannahme). */
export const STOCK_OBJECT_TYPE_ORDER_ACCEPTANCE: StockObjectType =
  'Warehouse::OrderAcceptance';
/** Backend-Typname des StockObject-Typs Order (Bestellung). */
export const STOCK_OBJECT_TYPE_ORDER: StockObjectType = 'Warehouse::Order';
/** Backend-Typname des StockObject-Typs Stock (Lager). */
export const STOCK_OBJECT_TYPE_STOCK: StockObjectType = 'Warehouse::Stock';
/** Backend-Typname der polymorphen StockObject-Basisklasse (target_type des Phase-2-Movements). */
export const STOCK_OBJECT_TYPE_STOCK_OBJECT = 'Warehouse::StockObject';
/** Backend-Typname des Cars, der bei Movements wie ein StockObject-Typ verwendet wird. */
export const STOCK_OBJECT_TYPE_CAR: StockObjectTypeCar = 'CarManagement::Car';

/**
 * export type StockMovementType =
 *   | 'Warehouse::StockMovements::NormalMovement'
 *   | 'Warehouse::StockMovements::ConsumptionMovement'
 *   | 'Warehouse::StockMovements::TrashMovement'
 *   | 'Warehouse::StockMovements::MachineTrashMovement'
 *   | 'Warehouse::StockMovements::OrderMovement'
 *   | 'Warehouse::StockMovements::CarTransferMovement'
 *   | 'Warehouse::StockMovements::CarRelocationMovement';
 */
/** Backend-Typname des StockMovement-Typs NormalMovement. */
export const STOCK_MOVEMENT_TYPE_NORMAL: StockMovementType =
  'Warehouse::StockMovements::NormalMovement';
/** Backend-Typname des StockMovement-Typs ConsumptionMovement (Verbrauch). */
export const STOCK_MOVEMENT_TYPE_CONSUMPTION: StockMovementType =
  'Warehouse::StockMovements::ConsumptionMovement';
/** Backend-Typname des StockMovement-Typs TrashMovement (Verwurf). */
export const STOCK_MOVEMENT_TYPE_TRASH: StockMovementType =
  'Warehouse::StockMovements::TrashMovement';
/** Backend-Typname des StockMovement-Typs MachineTrashMovement (Maschinen-Verwurf). */
export const STOCK_MOVEMENT_TYPE_MACHINE_TRASH: StockMovementType =
  'Warehouse::StockMovements::MachineTrashMovement';
/** Backend-Typname des StockMovement-Typs OrderMovement (Bestellung). */
export const STOCK_MOVEMENT_TYPE_ORDER: StockMovementType =
  'Warehouse::StockMovements::OrderMovement';
/** Backend-Typname des StockMovement-Typs CarTransferMovement (KFZ-Transfer). */
export const STOCK_MOVEMENT_TYPE_CAR_TRANSFER: StockMovementType =
  'Warehouse::StockMovements::CarTransferMovement';
/** Backend-Typname des StockMovement-Typs CarRelocationMovement (KFZ-Umbuchung). */
export const STOCK_MOVEMENT_TYPE_CAR_RELOCATION: StockMovementType =
  'Warehouse::StockMovements::CarRelocationMovement';
